import { render, staticRenderFns } from "./Provision.vue?vue&type=template&id=14f31942&scoped=true&lang=pug&"
import script from "./Provision.vue?vue&type=script&lang=js&"
export * from "./Provision.vue?vue&type=script&lang=js&"
import style0 from "./Provision.vue?vue&type=style&index=0&id=14f31942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f31942",
  null
  
)

export default component.exports